import { remoteUrl, urlWithParams } from "../../helpers/UrlHelpers";

const BASE_URL  = process.env.REACT_APP_CALLRECORDER_URL;
const DEFAULT_PARAMS  = { order_by: 'id', order: 'desc' };

function bundlesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/bundles`, params);
}
function bundlePath(this: any, id: number) {
  return `/${this.basePath}/bundles/${id}`;
}

const callrecorderUrls = {
  baseURL:        BASE_URL,
  basePath:       'callrecorder',
  remoteUrl:      remoteUrl,

  bundlesPath:    bundlesPath,
  bundlePath:     bundlePath,
}

export default callrecorderUrls;
